module.exports = __webpack_public_path__ + "img/stamp-negative.265c6f4d.png";